var map = {
	"./404/robot-lg.png": "7bra",
	"./404/robot-xs.png": "FoRM",
	"./about-us/founders/aboutus-ed-desktop.jpg": "sv/w",
	"./about-us/founders/aboutus-ed.jpg": "xplt",
	"./about-us/founders/cristina-desktop.jpg": "VXCH",
	"./about-us/founders/cristina-mobile.jpg": "24yt",
	"./about-us/founders/david-desktop.jpg": "fGpB",
	"./about-us/founders/david-mobile.jpg": "Ou/c",
	"./about-us/gallery/sanpablo-1-desktop.jpg": "XtIS",
	"./about-us/gallery/sanpablo-1.jpg": "0hz3",
	"./about-us/gallery/sanpablo-2-desktop.jpg": "yTR9",
	"./about-us/gallery/sanpablo-2.jpg": "DBiM",
	"./about-us/gallery/sanpablo-3-desktop.jpg": "NPlb",
	"./about-us/gallery/sanpablo-3.jpg": "1qDw",
	"./about-us/gallery/sanpablo-4-desktop.jpg": "rc61",
	"./about-us/gallery/sanpablo-4.jpg": "jfpW",
	"./about-us/gallery/sanpablo-5-desktop.jpg": "gfPO",
	"./about-us/gallery/sanpablo-5.jpg": "C3bi",
	"./about-us/hero/about-us-hero-desktop.jpg": "9RzD",
	"./about-us/hero/about-us-hero.jpg": "C/z0",
	"./about-us/hiring/aboutus-hiring-desktop.jpg": "Xd4u",
	"./about-us/hiring/aboutus-hiring.jpg": "AWdG",
	"./about-us/investors/dst.png": "aGR/",
	"./about-us/investors/foundersfund.png": "k/5r",
	"./about-us/investors/kaszek.png": "uOzq",
	"./about-us/investors/qed.png": "nsit",
	"./about-us/investors/sequoia.png": "u8fL",
	"./about-us/investors/tcv.png": "S5yK",
	"./about-us/investors/tencent.png": "bfM2",
	"./about-us/investors/tiger.png": "79Ko",
	"./about-us/prizes/fastcompany.png": "5uxy",
	"./about-us/prizes/forbes.png": "jmWs",
	"./about-us/prizes/kpmg.png": "2rFg",
	"./about-us/testimonials/aboutus-xpeer-desktop.jpg": "1L3a",
	"./about-us/testimonials/aboutus-xpeer.jpg": "bF+H",
	"./cdt/cdt-vs-cajitas/cajita-con-cdt-nu.png": "mep1",
	"./cdt/cdt-vs-cajitas/cajita-nu.png": "0MkW",
	"./cdt/decorative-section/bars-lg.jpg": "YWA9",
	"./cdt/decorative-section/bars-md.jpg": "LjQT",
	"./cdt/decorative-section/bars-xs.jpg": "nzrN",
	"./cdt/hero/hero-lg.jpg": "4JlH",
	"./cdt/hero/hero-md.jpg": "y6vc",
	"./cdt/hero/hero-xs.jpg": "f9e+",
	"./cdt/mechanics/choose-maturity-period.png": "NVL0",
	"./cdt/mechanics/choose-money-box.gif": "n1hJ",
	"./cdt/mechanics/choose-money-box.png": "ej3L",
	"./cdt/mechanics/define-investment.png": "XQym",
	"./cdt/mechanics/get-earnings.gif": "6dF3",
	"./cdt/mechanics/get-earnings.png": "8WJZ",
	"./cdt/mechanics/look-earnings.png": "mYqW",
	"./credit-card/hero/credit-card-hero-lg-1x.jpg": "0o/x",
	"./credit-card/hero/credit-card-hero-md-1x.jpg": "VO6Q",
	"./credit-card/hero/credit-card-hero-xs-1x.jpg": "hM+s",
	"./credit-card/pay/animated-logo.gif": "xY0A",
	"./credit-card/pay/apple-pay-mini.png": "Nuab",
	"./credit-card/pay/apple-pay.png": "HjK4",
	"./credit-card/pay/google-pay.png": "ZGlf",
	"./credit-card/pay/google-wallet-mini.png": "UtIy",
	"./credit-card/product-information/app-avatar-4x.png": "ppHh",
	"./credit-card/product-information/document-avatar-4x.png": "tVYT",
	"./credit-card/product-information/product-information-lg-1x.jpg": "MPmm",
	"./credit-card/product-information/product-information-md-1x.jpg": "/LOR",
	"./credit-card/product-information/product-information-xs-1x.jpg": "BIb9",
	"./credit-card/promise/adjust-credit-limit.gif": "4rS8",
	"./credit-card/promise/cash-advances.gif": "/bdh",
	"./credit-card/promise/instalments-change.gif": "Mu/+",
	"./credit-card/seo/website-thumb-large.jpg": "I0OB",
	"./credit-card/seo/website-thumb.jpg": "SFcK",
	"./credit-card/value-proposal/value-proposal-lg-2x.png": "zcPW",
	"./credit-card/value-proposal/value-proposal-md-2x.png": "lyFh",
	"./credit-card/value-proposal/value-proposal-xs-2x.png": "bz5n",
	"./credit-card/value-proposal/value-proposal.gif": "43zK",
	"./email-verification/email-verification-loading.png": "h9RO",
	"./email-verification/email-verification-success.jpg": "Ny5S",
	"./ethic-and-compliance/aml/Nubank_HickDuarte_59058 1_lg.png": "EeLF",
	"./ethic-and-compliance/aml/Nubank_HickDuarte_59058 1_md.png": "rk2B",
	"./ethic-and-compliance/aml/Nubank_HickDuarte_59058 1_xs.png": "sRIk",
	"./ethic-and-compliance/code-of-conduct/Nubank_HickDuarte_55193_lg.jpg": "OACN",
	"./ethic-and-compliance/code-of-conduct/Nubank_HickDuarte_55193_md.jpg": "VT+Y",
	"./ethic-and-compliance/code-of-conduct/Nubank_HickDuarte_55193_xs.jpg": "pT9a",
	"./ethic-and-compliance/compliance-policy/Nubank_HickDuarte_58741_lg.jpg": "OQ//",
	"./ethic-and-compliance/compliance-policy/Nubank_HickDuarte_58741_md.jpg": "DUe9",
	"./ethic-and-compliance/compliance-policy/Nubank_HickDuarte_58741_xs.jpg": "R74v",
	"./ethic-and-compliance/header/Nubank_HickDuarte_57380_lg.png": "7nWF",
	"./ethic-and-compliance/header/Nubank_HickDuarte_57380_md.png": "W8BT",
	"./ethic-and-compliance/header/Nubank_HickDuarte_57380_xs.png": "Dvw9",
	"./ethic-and-compliance/info-parker/NU_ComplianceTeam_ParkerLogo-08 1_lg.png": "XQ1l",
	"./ethic-and-compliance/info-parker/NU_ComplianceTeam_ParkerLogo-08 1_md.png": "yFGi",
	"./ethic-and-compliance/info-parker/NU_ComplianceTeam_ParkerLogo-08 1_xs.png": "K4lO",
	"./ethic-and-compliance/mission/Nubank_HickDuarte_54700_lg.jpg": "ooZI",
	"./ethic-and-compliance/mission/Nubank_HickDuarte_54700_md.jpg": "82lN",
	"./ethic-and-compliance/mission/Nubank_HickDuarte_54700_xs.jpg": "CuIq",
	"./ethic-and-compliance/procedure/Protect yourself_lg.png": "66ms",
	"./ethic-and-compliance/procedure/Protect yourself_md.png": "OiOg",
	"./ethic-and-compliance/supplier-code-of-conduct/Nubank_HickDuarte_58654 (2) 1_lg.jpg": "l8wf",
	"./ethic-and-compliance/supplier-code-of-conduct/Nubank_HickDuarte_58654 (2) 1_md.jpg": "Mzl+",
	"./ethic-and-compliance/supplier-code-of-conduct/Nubank_HickDuarte_58654 (2) 1_xs.jpg": "vo1m",
	"./home/banner/savingsbanner-lg-2x.jpg": "MlmR",
	"./home/banner/savingsbanner-md-1-5x.jpg": "nzAM",
	"./home/banner/savingsbanner-xs-1x.jpg": "PxOI",
	"./home/blog/blog-075x.jpg": "yyq+",
	"./home/blog/blog-15x.jpg": "Uctw",
	"./home/blog/blog-1x.jpg": "19Ph",
	"./home/hero/hero-100m-desktop.jpg": "BmI6",
	"./home/hero/hero-100m-mobile.jpg": "JK0M",
	"./home/hero/hero-100m-tablet.jpg": "nTRZ",
	"./home/hero/hero-desktop-large-v1.jpg": "xXsX",
	"./home/hero/hero-desktop-v1.jpg": "oxla",
	"./home/hero/hero-mobile-v1.jpg": "/T9V",
	"./home/perks/perks-075x.jpg": "it+p",
	"./home/perks/perks-15x.jpg": "/wSw",
	"./home/perks/perks-1x.jpg": "CjUb",
	"./mgm/mgm-lg-2.png": "MMel",
	"./mgm/mgm-lg-2x-v2.jpg": "ElPU",
	"./mgm/mgm-lg-2x.jpg": "uClk",
	"./mgm/mgm-md-2.png": "5dyC",
	"./mgm/mgm-md-2x.jpg": "iVsS",
	"./mgm/mgm-xs-2.png": "ExRY",
	"./mgm/mgm-xs-2x.jpg": "gsTT",
	"./mgm/ticket-01-01.png": "rx8V",
	"./mgm/ticket-01-02.png": "Gb2l",
	"./mgm/ticket-01-03.png": "aEVp",
	"./mgm/ticket-02-01.png": "tXto",
	"./mgm/ticket-02-02.png": "Wwps",
	"./mgm/ticket-02-03.png": "FhIh",
	"./multi-product-home/blog/blog-lg-1x.jpg": "L+E7",
	"./multi-product-home/blog/blog-xs-1x.jpg": "zjMj",
	"./multi-product-home/contract/contract.png": "TDW6",
	"./multi-product-home/footer/footer-fogafin-4x.png": "OB81",
	"./multi-product-home/footer/footer-fogafin-cucuta-4x.png": "NweW",
	"./multi-product-home/footer/footer-sic-4x.png": "83Ml",
	"./multi-product-home/footer/footer-superfinanciera-4x.png": "xNf1",
	"./multi-product-home/footer/logos-compliance.png": "m/fa",
	"./multi-product-home/hero/hero-cultural-hack-xs-2x.jpg": "OEd3",
	"./multi-product-home/hero/hero-lg-1x.jpg": "KTBb",
	"./multi-product-home/hero/hero-md-1x.jpg": "/26m",
	"./multi-product-home/hero/hero-xs-1x.jpg": "pF5i",
	"./multi-product-home/perks/cucuta-perks-lg-1x.jpg": "REOD",
	"./multi-product-home/perks/cucuta-perks-md-1x.jpg": "Idtf",
	"./multi-product-home/perks/cucuta-perks-xs-2x.jpg": "50YP",
	"./multi-product-home/perks/perks-lg-2x.jpg": "XMwi",
	"./multi-product-home/perks/perks-md-2x.jpg": "40UG",
	"./multi-product-home/perks/perks-xs-2x.jpg": "pitX",
	"./multi-product-home/products/credits/creditsprd-lg.jpg": "jzlm",
	"./multi-product-home/products/credits/creditsprd-md.jpg": "Z3DS",
	"./multi-product-home/products/credits/creditsprd-xs.jpg": "F815",
	"./multi-product-home/products/credits/perks/credit-card-perks-lg-1x.png": "mzGS",
	"./multi-product-home/products/credits/perks/credit-card-perks-md-1x.png": "/lzq",
	"./multi-product-home/products/credits/perks/credit-card-perks-xs-1x.gif": "EARR",
	"./multi-product-home/products/credits/perks/credit-card-perks-xs-1x.png": "VwCs",
	"./multi-product-home/products/savings/fogafin.png": "z+v5",
	"./multi-product-home/products/savings/perks/savings-perks.gif": "7JM8",
	"./multi-product-home/products/savings/savings-lg.jpg": "BdU7",
	"./multi-product-home/products/savings/savings-md.jpg": "x8bB",
	"./multi-product-home/products/savings/savings-without-logos-lg-2x.jpg": "X0N1",
	"./multi-product-home/products/savings/savings-without-logos-md-2x.jpg": "hxf+",
	"./multi-product-home/products/savings/savings-without-logos-xs-2x.jpg": "juPT",
	"./multi-product-home/products/savings/savings-xs.jpg": "lmvt",
	"./multi-product-home/products/savings/vigilado-superfn.png": "jI6S",
	"./password/celebrate.jpg": "ZS66",
	"./press/hero/press-hero-desktop.jpg": "Pdla",
	"./press/hero/press-hero.jpg": "K2Ml",
	"./press/media/medium-fastcompany.png": "+mqD",
	"./press/media/medium-nyt.png": "ugk4",
	"./press/media/medium-reuters.png": "oVog",
	"./press/media/medium-techcrunch.png": "z2+f",
	"./press/media/press-media-desktop.jpg": "kIOQ",
	"./press/media/press-media.jpg": "uKyU",
	"./pse-payment-authorization/desktop-lg.jpg": "4JvP",
	"./pse-payment-authorization/pse-payment-desktop-lg.jpg": "l3IJ",
	"./registration/cardHasArrivedDebit.svg": "Yft2",
	"./registration/cardMoradita.svg": "wd13",
	"./registration/floatingCard.svg": "2DCi",
	"./registration/handEmail.svg": "G5IA",
	"./registration/highFive.svg": "wLHC",
	"./registration/improving.svg": "nLFZ",
	"./registration/merchant.svg": "A+pP",
	"./registration/nuis_light_heart.svg": "2MFX",
	"./registration/openAppQrCode.jpg": "TjVU",
	"./registration/openBankingConfirmation.svg": "MHvY",
	"./registration/savingsPlant.svg": "Ec4N",
	"./registration/wellDone.svg": "zyDY",
	"./registration/wellDoneHiFive.svg": "HV7E",
	"./savings-waitlist/blog/blog1-lg.png": "Pyto",
	"./savings-waitlist/blog/blog1-xs.png": "+57Q",
	"./savings-waitlist/blog/blog2-lg.png": "a2/p",
	"./savings-waitlist/blog/blog2-xs.png": "ViCC",
	"./savings-waitlist/blog/blog3-lg.png": "+8mY",
	"./savings-waitlist/blog/blog3-xs.png": "L0D+",
	"./savings-waitlist/blog/blog3a-lg.jpg": "OJ7i",
	"./savings-waitlist/blog/blog3a-xs.jpg": "kMGb",
	"./savings-waitlist/hero/hero-lg.jpg": "ZMA3",
	"./savings-waitlist/hero/hero-md.jpg": "w9Vi",
	"./savings-waitlist/hero/hero-xs.jpg": "VvJ9",
	"./savings-waitlist/promise/savings-waitlist-promise-1a-lg-2x.jpg": "CTfb",
	"./savings-waitlist/promise/savings-waitlist-promise-1a-xs-1x.jpg": "UfYI",
	"./savings-waitlist/promise/savings-waitlist-promise-1b-lg-1x.jpg": "eafg",
	"./savings-waitlist/promise/savings-waitlist-promise-3b-lg-1x.jpg": "lDNA",
	"./savings-waitlist/promise/savings-waitlist-promise-3b-lg-2x.jpg": "OnYw",
	"./savings-waitlist/promise/savings-waitlist-promise-3b-xs-1x.jpg": "2hVX",
	"./savings-waitlist/value-proposal/cuenta.png": "1k0j",
	"./savings/blog/blog3a-lg.jpg": "ToyX",
	"./savings/blog/blog3a-xs.jpg": "o99L",
	"./savings/blog/blog4-lg.png": "ctar",
	"./savings/blog/blog4-xs.png": "pFcg",
	"./savings/blog/cajita-lg.png": "VMU6",
	"./savings/blog/cajita-xs.png": "7oIs",
	"./savings/blog/instant-pay-xs.png": "NCqf",
	"./savings/blog/instant-pay.jpg": "UpA2",
	"./savings/blog/sarlaft-lg.png": "sBnQ",
	"./savings/blog/sarlaft-xs.png": "uwbY",
	"./savings/hero/savings-hero-lg.jpg": "PXAg",
	"./savings/hero/savings-hero-md.jpg": "tHBv",
	"./savings/hero/savings-hero-xs.jpg": "5G1X",
	"./savings/pay/apple-pay-mini.png": "mbsC",
	"./savings/pay/apple-pay.png": "3Cim",
	"./savings/pay/google-pay.png": "GS4Z",
	"./savings/pay/google-wallet-mini.png": "kMDF",
	"./savings/placa/WhatIsNuPlaca.png": "eWEj",
	"./savings/placa/WhereCanISeeIt.png": "0G0h",
	"./savings/product-information/add-person-avatar-4x.png": "Lqjc",
	"./savings/product-information/app-avatar-4x.png": "Faec",
	"./savings/product-information/product-information-lg-1x.jpg": "vud2",
	"./savings/product-information/product-information-md-1x.jpg": "7vKM",
	"./savings/product-information/product-information-xs-1x.jpg": "60ix",
	"./savings/promise/NoManagementFee.png": "vpUG",
	"./savings/promise/NoTransferFee.png": "w9Qy",
	"./savings/promise/YourMoneyIsGrowing.png": "tH92",
	"./savings/promise/iPhone12pro_1.png": "Kqq+",
	"./savings/promise/iPhone12pro_2.png": "/hoE",
	"./savings/promise/iPhone12pro_3.png": "D0Eq",
	"./savings/seo/website-thumb-large.jpg": "Z+bW",
	"./savings/seo/website-thumb.jpg": "tTh4",
	"./savings/value-proposal.png": "yJ/Z",
	"./savings/value_proposal_lg.png": "643J",
	"./savings/value_proposal_md.png": "H71k",
	"./savings/value_proposal_xs.png": "90YK",
	"./savings/vigilado-left.png": "a704",
	"./savings/vigilado-xl.png": "e8tW",
	"./savings/vigilado.png": "EkFu",
	"./secured-card/for-who/for-who-md.jpg": "Qwno",
	"./secured-card/for-who/for-who-xs.jpg": "gK+i",
	"./secured-card/hero/hero-lg.jpg": "07bA",
	"./secured-card/hero/hero-md.jpg": "sdb7",
	"./secured-card/hero/hero-xs.jpg": "Bwak",
	"./secured-card/history-path/card.png": "0oZY",
	"./secured-card/history-path/missions.png": "Tv6L",
	"./secured-card/history-path/payed.png": "2G8c",
	"./secured-card/history-path/sec.gif": "DlR/",
	"./seo/mgm/mgm-invite-ticket-1.jpg": "jhsJ",
	"./seo/mgm/mgm-invite-ticket-2.jpg": "vOBE",
	"./seo/mgm/mgm-invite-ticket-3.jpg": "H64P",
	"./seo/mgm/mgm-invite-ticket-4.jpg": "BPHC",
	"./seo/mgm/mgm-invite-ticket-5.jpg": "oDaN",
	"./seo/mgm/mgm-invite-ticket-6.jpg": "J+B0",
	"./seo/open-graph-experiment-large.jpg": "z4PN",
	"./seo/open-graph-experiment.jpg": "eD+z",
	"./seo/open-graph-large.jpg": "Wd0J",
	"./seo/open-graph.jpg": "r7dD",
	"./seo/website-mgm-thumb-large.jpg": "JQe/",
	"./seo/website-thumb-large.jpg": "6cYH",
	"./seo/website-thumb.jpg": "+4UH",
	"./world-cup/benefits/cart-outline.svg": "GXQL",
	"./world-cup/benefits/smartphone.svg": "xOwr",
	"./world-cup/benefits/withdrawal.svg": "aE8a",
	"./world-cup/credit-card/nuapp@1x.png": "aXpU",
	"./world-cup/credit-card/nuapp@2x.png": "A9re",
	"./world-cup/credit-card/nuapp@3x.png": "TCfC",
	"./world-cup/fifa/fifa-logo.svg": "4LYc",
	"./world-cup/fifa/nu-fifa-logo@2x.png": "o836",
	"./world-cup/fifa/nu-fifa-logo@3x.png": "v17x",
	"./world-cup/finance/phone@1x.png": "Bo7t",
	"./world-cup/finance/phone@2x.png": "LCuX",
	"./world-cup/finance/phone@3x.png": "UYP2",
	"./world-cup/hero/ana_1@3x.png": "MZKG",
	"./world-cup/hero/background@1x.png": "6l1b",
	"./world-cup/hero/background@2x.png": "Sheo",
	"./world-cup/hero/background@3x.png": "ReQ6",
	"./world-cup/hero/diana_1@3x.png": "AdIT",
	"./world-cup/hero/jorge_1@3x.png": "g5Y9",
	"./world-cup/hero/mateo_1@3x.png": "oB3m",
	"./world-cup/hero/players@3x.png": "rXxn",
	"./world-cup/hero/rec-group-white.svg": "oh0E",
	"./world-cup/hero/rec-group.svg": "T+tY",
	"./world-cup/hero/worldcup-lg-2x.jpg": "i3kd",
	"./world-cup/hero/worldcup-md-2x.jpg": "xs9y",
	"./world-cup/hero/worldcup-xs-2x.jpg": "XGrE",
	"./world-cup/invite/join-us-md-3x.png": "w5f/",
	"./world-cup/invite/join-us-xs-1x.png": "UvXv",
	"./world-cup/invite/join-us-xs-2x.png": "j6kB",
	"./world-cup/invite/word-cup-lg-3x.png": "0FdT",
	"./world-cup/invite/word-cup-md-3x.png": "0Xn8",
	"./world-cup/invite/word-cup-xs-1x.png": "Sg0M",
	"./world-cup/signup/hick@1x.png": "eveJ",
	"./world-cup/signup/hick@2x.png": "rYo1",
	"./world-cup/signup/hick@3x.png": "oKOJ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "F6xdk";